import React from 'react'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import Text from '../../../atoms/text/Text'
import Icon from '../../../atoms/icon/Icon'
import { TeamsWithColours } from '../RoundResults'
import './TeamPositions.scss'
import { useResultsContext } from '../context/context'

interface Props {
  teamPositions: Array<Type>
  teams: TeamsWithColours[]
}

interface Type {
  teamId: number
  position: number
}

const TeamPositions: React.FC<Props> = ({
  teamPositions,
  teams
}) => {
  const context = useResultsContext()
  return (
    <InlineGroup stretch verticalCenter spaceLeft={10} className={'positions-container '}>
      {teamPositions.map((p, i) => {
        const teamForPosition = teams.find(t => t.teamId === p.teamId)
        return (
          <VerticalGroup key={`position-${i}`} center spaceBetweenElements={2} className='icon-item' style={{ animationDelay: context.noAnimations ? '0s' : `${teams.length + 1 + i}s` }}>
            {p.position === 1 && <Icon type='goldMedal' fill={teamForPosition?.colour} size={16} noMargin></Icon>}
            {p.position === 2 && <Icon type='silverMedal' fill={teamForPosition?.colour} size={16} noMargin></Icon>}
            {p.position === 3 && <Icon type='bronzeMedal' fill={teamForPosition?.colour} size={16} noMargin></Icon>}
            <div style={{color: teamForPosition?.colour}}><Text bold size='md'>{teamForPosition?.teamName}</Text></div>
          </VerticalGroup>
        )
      })}
    </InlineGroup>
  )
}

export default TeamPositions